<template style="overflow: visible; z-index: 300">
  <v-dialog
    style="z-index: 300;"
    @keydown.esc="isOpen=false"
    persistent
    v-model="isOpen"
    max-width="1350">
    <v-card>
      <v-card-title>
        Selecciona la factura que deseas relacionar
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-model="invoicesTable.selected"
          :loading-text="invoicesTable.title"
          :loading="invoicesTable.loading"
          :headers="invoicesTable.headers"
          :items="invoicesTable.data"
          :options="invoicesTable.options"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 40, 50]
          }"
          :server-items-length="invoicesTable.total"
          class="elevation-1"
          item-key="id"
          @update:options="updateInvoicesTable">
          <template v-slot:top>
            <div class="px-3">
              <v-row>
                <v-col cols="12" md="3">
                  <div class="d-flex align-center">
                    <span class="mr-3">
                      Filtros:
                    </span>
                    <v-menu
                      ref="datePicker"
                      v-model="datePicker"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="downloadDates"
                          label="Rango de fechas"
                          prepend-icon="mdi-calendar"
                          outlined
                          rounded
                          readonly
                          hide-details
                          dense
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="downloadDates"
                        ref="picker"
                        color="primary"
                        range
                        :first-day-of-week="1"
                        :allowed-dates="allowedDates"
                        @input="orderDateRange"
                        reactive
                        no-title
                        :locale="locale"
                      >
                        <div>
                          <div class="d-flex">
                            <v-btn text color="primary" @click="resetDate">Borrar</v-btn>
                            <v-spacer/>
                            <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                            <v-btn :disabled="downloadDates.length < 2" color="primary" @click="confirmDownload">OK</v-btn>
                          </div>
                        </div>
                      </v-date-picker>
                    </v-menu>
                  </div>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    solo
                    rounded
                    dense
                    clearable
                    v-model="issuerTaxid"
                    @change="loadInvoices"
                    @click:clear="resetData(1)"
                    :disabled="downloadDates.length < 2"
                    :label="$t('expenses.registerMovements.invoices.downloadDialog.issuerTaxIdLabel')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    solo
                    rounded
                    dense
                    clearable
                    v-model="issuerName"
                    @change="loadInvoices"
                    @click:clear="resetData(2)"
                    :disabled="downloadDates.length < 2"
                    label="Buscar por proveedor"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3">
                  <div class="d-flex justify-start">
                    <div class="px-1">
                      <v-text-field
                        v-model.number="min"
                        class="mt-0 pt-0"
                        single-line
                        label="Min"
                        type="number"
                        clearable
                        @click:clear="asignMin(min)"
                        style="width: 95px"
                      ></v-text-field>
                    </div>
                    <div class="px-1">-</div>
                    <div class="px-1">
                      <v-text-field
                        v-model.number="max"
                        class="mt-0 pt-0"
                        single-line
                        label="Max"
                        type="number"
                        clearable
                        @click:clear="asignMax(max)"
                        style="width: 95px"
                      ></v-text-field>
                    </div>
                    <div>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            x-small
                            fab
                            depressed
                            :disabled="min === null || max === null"
                            v-on="on"
                            @click="filterByAmount">
                            <v-icon>
                              mdi-chevron-right
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          Filtrar por monto
                        </span>
                      </v-tooltip>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </template>
          <template v-slot:[`item.id`]="{ item }">
            <v-simple-checkbox
              v-if="item.selectable && item.items.length"
              @input="toggleInvoice(item)"
              :value="isSelectedInvoice(item)"
              :ripple="false"
            />
            <span v-else class="primary--text">
               Relacionada
            </span>
          </template>
          <template v-slot:[`item.uuid`]="{ item }">
            <a  href="" @click.prevent="openDetail(item)">{{ item.uuid }}</a>
          </template>
          <template v-slot:[`item.issuer`]="{ item }">
            <div>
              {{ item.issuer.name }}
            </div>
          </template>
          <template v-slot:[`item.total`]="{ item }">
            <div class="text-right">
              {{ item.total | toFix2 | numberWithComma | prefix('$') }} {{ item.currency }}
            </div>
          </template>
          <template v-slot:[`item.issuedAt`]="{ item }">
            <div>
              {{ $moment(item.issuedAt).format('DD/MM/YYYY') }}
            </div>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          class="mr-4"
          outlined
          rounded
          small
          @click="closeRelateInvoiceDialog">
          Cancelar
        </v-btn>
        <v-btn
          :disabled="!invoicesTable.selected.length"
          color="primary"
          rounded
          small
          depressed
          @click="checkDiffDates">
          Relacionar factura
        </v-btn>
      </v-card-actions>
    </v-card>
    <InvoiceViewer ref="invoiceViewer" />
    <v-dialog @keydown.esc="sameMonthDialog=false" v-model="sameMonthDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">
            Selecciona una fecha
          </span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12">
                <div>
                  Usa esta opción para escoger que fecha quieres tomar en cuenta para que se guarde en la factura.
                </div>
                <div>
                  <v-radio-group v-model="useOrderDate" :rules="rulesRadioButton.required" >
                    <template v-slot:label>
                      <div class="radioTitle">¿En qué fecha debería entrar esta factura?</div>
                    </template>
                    <v-radio
                      :label="'Fecha de pago: ' + formatDate(orderDate)"
                      value=true
                      class="ml-6 radio"
                      color="primary"
                      off-icon="mdi-circle"
                      on-icon="mdi-record-circle"
                    ></v-radio>
                    <v-radio
                      :label="'Fecha de facturación: ' + formatDate(issuedAt)"
                      value=false
                      class="ml-6 radio"
                      color="primary"
                      off-icon="mdi-circle"
                      on-icon="mdi-record-circle"
                    ></v-radio>
                  </v-radio-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            depressed
            @click="closeDiffDates"
            >
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            small
            depressed
            @click="relateInvoiceToPayorder"
            :disabled="!useOrderDate"
            >
            Relacionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import { cloneDeep } from 'lodash'

import InvoiceViewer from '@/components/modals/InvoiceViewer'
import getLocale from '@/lang/locale'
const { parseStringPromise } = require('xml2js')

export default {
  props: {
    orders: {
      type: Array
    }
  },
  components: {
    InvoiceViewer
  },
  data () {
    return {
      isOpen: false,
      disabled: false,
      datePicker: false,
      issuerName: '',
      overlay: false,
      invoicesTable: {
        title: this.$i18n.t('expenses.registerMovements.invoices.loading'),
        loading: false,
        headers: [
          { text: '', value: 'id', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.invoices.headers.id'), value: 'uuid', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.invoices.headers.supplier'), value: 'issuer', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.invoices.headers.receiver'), value: 'receiver.name', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.invoices.headers.amount'), value: 'total' },
          { text: this.$i18n.t('expenses.registerMovements.invoices.headers.date'), value: 'issuedAt' }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 30,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        },
        selected: []
      },
      search: '',
      isGeneratePayOrderPanelOpen: false,
      downloadDates: [],
      invoice: null,
      invoiceType: 'I',
      issuerTaxid: '',
      invoices: {
        data: []
      },
      invoiceToRelate: null,
      min: null,
      max: null,
      sameMonthDialog: false,
      useOrderDate: null,
      rulesRadioButton: {
        required: [v => !!v || `Este campo ${this.$i18n.t('messages.isRequired')}`]
      },
      issuedAt: '',
      orderDate: ''
    }
  },
  computed: {
    restaurantTaxid () {
      return this.$store.state.currentRestaurant.taxInformation.data ? (this.$store.state.currentRestaurant.taxInformation.data.taxId || '') : ''
    },
    locale () {
      return getLocale(this.$i18n.locale)
    },
    movementsPermissions () {
      return this.$store.state.login.permissions['expenses'].components['financial-movements'].actions
    }
  },
  watch: {
    'invoices.data': function () {
      this.invoicesTable.selected = []
      this.invoicesTable.data = this.invoices.data
    },
    '$store.state.currentRestaurant.data': async function (val) {
      this.resetForm()
    }
  },
  methods: {
    open () {
      this.isOpen = true
    },
    async closeRelateInvoiceDialog () {
      this.isOpen = false
      await this.resetForm()
      this.$emit('close', false)
    },
    toggleInvoice (invoice) {
      const index = this.invoicesTable.selected.findIndex(i => i.id === invoice.id)

      this.invoicesTable.selected.pop()
      if (index < 0) {
        this.invoicesTable.selected.push(invoice)
      }
    },
    isSelectedInvoice (invoice) {
      return this.invoicesTable.selected.some(i => i.id === invoice.id)
    },
    async resetData (options) {
      if (options === 1) this.issuerTaxid = ''
      if (options === 2) this.issuerName = ''
      await this.loadInvoices()
    },
    resetForm () {
      this.invoicesTable.data = []
      this.invoicesTable.total = 0
      this.invoicesTable.selected = []
      this.isGeneratePayOrderPanelOpen = false
      this.downloadDates = []
      this.invoice = null
      this.invoiceType = 'I'
      this.invoices.data = []
      this.disabled = false
    },
    async getXml (id) {
      let xml = null
      this.disabled = true
      try {
        const { invoice } = await this.$api.get(`/v1/invoices/${id}/cfdi`)
        xml = invoice
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.disabled = false
      return xml
    },
    async openDetail (item) {
      const invoice = cloneDeep(item)
      if (item.invoice) {
        item.xml = item.invoice
        await this.$refs.invoiceViewer.open(item)
      } else {
        invoice.xml = await this.getXml(item.id)
        await this.$refs.invoiceViewer.open(invoice)
      }
    },
    async resetDate () {
      this.downloadDates = []
      await this.loadInvoices()
      this.datePicker = false
    },
    async loadInvoices (params = null) {
      params = {
        startDate: moment(this.downloadDates[0]).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
        endDate: moment(this.downloadDates[1] || this.downloadDates[0]).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
        rfc: this.restaurantTaxid,
        issuerName: this.issuerName,
        status: 'VIGENTE',
        isIssuer: false,
        type: this.invoiceType,
        limit: this.invoicesTable.options.itemsPerPage,
        page: this.invoicesTable.options.page,
        rfcIssuer: this.issuerTaxid,
        ...params
      }
      if (this.min !== null && this.max !== null) {
        params.totalMin = this.min
        params.totalMax = this.max
      }
      this.invoicesTable.loading = true
      try {
        const response = await this.$api.get(`/v1/invoices`, params)
        this.invoicesTable.data = response.items.sort(i => i.selectable ? -1 : 1)
        this.invoicesTable.total = response.total
        this.datePicker = false
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.invoicesTable.loading = false
    },
    async updateInvoicesTable (options) {
      if (this.downloadDates.length) {
        const params = {
          startDate: moment(this.downloadDates[0]).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
          endDate: moment(this.downloadDates[1] || this.downloadDates[0]).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
          rfc: this.restaurantTaxid,
          status: 'VIGENTE',
          isIssuer: false,
          type: this.invoiceType,
          limit: options.itemsPerPage,
          page: options.page,
          totalMin: this.min,
          totalMax: this.max,
          sort: options.sortDesc[0] ? 'desc' : 'asc'
        }
        await this.loadInvoices(params)
      }
    },
    openGeneratePayOrderPanel () {
      this.isGeneratePayOrderPanelOpen = true
    },
    confirmDownload () {
      this.loadInvoices()
    },
    allowedDates (val) {
      const nowDate = new Date()
      const evalDate = new Date(moment(val).format('YYYY-MM-DDTHH:mm:ss.SSS'))
      const len = this.downloadDates.length

      if (len) {
        if (len === 2) {
          return evalDate.getTime() <= nowDate.getTime()
        }
        const selectedDate = new Date(moment(this.downloadDates[0]).format('YYYY-MM-DDTHH:mm:ss.SSS'))
        const selectedDate2 = new Date(moment(this.downloadDates[0]).format('YYYY-MM-DDTHH:mm:ss.SSS'))
        const topLimitDate = new Date(selectedDate.setMonth(selectedDate.getMonth() + 1))
        const bottomLimitDate = new Date(selectedDate2.setMonth(selectedDate2.getMonth() - 1))

        return evalDate.getTime() <= nowDate.getTime() &&
          evalDate.getTime() <= topLimitDate.getTime() &&
          evalDate.getTime() >= bottomLimitDate.getTime()
      }

      return evalDate.getTime() <= nowDate.getTime()
    },
    orderDateRange () {
      this.downloadDates.sort((a, b) => new Date(a) - new Date(b))
    },
    async relateInvoiceToPayorder () {
      this.overlay = true
      try {
        const invoice = await this.getInvoice(this.invoicesTable.selected[0].id)
        const payload = {
          xml: invoice,
          orders: this.orders.map(payOrder => payOrder._id),
          useOrderDate: this.useOrderDate
        }
        await this.$api.post(`/v1/expenses/${this.$store.state.currentRestaurant.data._id}/attach-invoice`, payload)
        this.$toasted.show('Se anexó correctamente la factura.', { duration: 3000 })
        this.closeRelateInvoiceDialog()
        this.$emit('refresh')
        this.useOrderDate = null
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async checkDiffDates () {
      const invoice = await this.getInvoice(this.invoicesTable.selected[0].id)
      const content = await parseStringPromise(invoice)
      const issuedAt = moment(content['cfdi:Comprobante'].$.Fecha)

      let payorderDate = ''

      for (const order of this.orders) {
        const orderStatusChange = order.statusChanges.find(status => status.name === 'paid')
        if (payorderDate.length > 0) {
          if (orderStatusChange.createdAt > payorderDate) payorderDate = orderStatusChange.createdAt
        } else {
          payorderDate = orderStatusChange.createdAt
        }
      }

      const sameMonth = issuedAt.isSame(payorderDate, 'month')
      this.orderDate = payorderDate
      this.issuedAt = issuedAt
      if (!sameMonth) {
        this.sameMonthDialog = true
      } else {
        this.relateInvoiceToPayorder()
      }
    },
    formatDate (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    closeDiffDates () {
      this.useOrderDate = null
      this.sameMonthDialog = false
    },
    getInvoice: async function (invoiceId) {
      const { invoice } = await this.$api.get(`/v1/invoices/${invoiceId}/cfdi`)
      return invoice
    },
    asignMax (val) {
      this.max = val
    },
    asignMin (val) {
      this.min = val
    },
    filterByAmount: async function () {
      await this.loadInvoices()
    }
  }
}
</script>
